// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"Spinner_spinnerWrapper__rTq0T"};